import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Multistep } from '@/components/multistep/Multistep';
import { Step } from '@/components/multistep/Questionnaire';
import { Card } from '@/components/sections/Card';
import { CSVProvider } from '@/services/csv/CSVService';

import { FunctionComponent, Suspense } from 'react';
import { FinanceModelIssuesStep } from './steps/FinanceModelIssuesStep';
import { ReviewFinanceModelCategoriesStep } from './steps/ReviewFinanceModelCategoriesStep';
import { ReviewFinanceModelManufacturersStep } from './steps/ReviewFinanceModelManufacturersStep';
import { ReviewFinanceModelRegionStep } from './steps/ReviewFinanceModelRegionStep';
import { ReviewFinanceModelStep } from './steps/ReviewFinanceModelStep';
import { UploadFinanceModelStep } from './steps/UploadFinanceModelStep';

const BulkUploadFinanceModelModal: FunctionComponent<ModalProps> = props => {
  const BulkUploadFinanceModel = () => (
    <Card className="w-full p-8 max-h-[90vh] overflow-y-auto">
      <Modal.Controls {...props}>
        <h1 className="text-2xl font-semibold mb-2">Bulk upload finance models</h1>
      </Modal.Controls>
      <CSVProvider>
        <Multistep>
          <UploadFinanceModelStep />
          <Step
            id="issues"
            title="Issues"
            description="There were some issues with parsing or validating the spreadsheet. Please resolve them and reupload the spreadsheet."
            controls="manual"
          >
            <FinanceModelIssuesStep />
          </Step>
          <Step
            id="manufacturers"
            title="Review manufacturers"
            description="There are manufacturers referenced in the uploaded finance models that don't exist or can't be automatically found. Please either create or fix the manufacturers below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewFinanceModelManufacturersStep />
            </Suspense>
          </Step>
          <Step
            id="categories"
            title="Review categories"
            description="There are categories referenced in the uploaded finance models that don't exist or can't be automatically found. Please either create or fix the categories below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewFinanceModelCategoriesStep />
            </Suspense>
          </Step>
          <Step
            id="regions"
            title="Review regions"
            description="There are regions referenced in the uploaded products that don't exist or can't be automatically found. Please either create or fix the categories below."
            controls="manual"
          >
            <Suspense fallback={<Loading />}>
              <ReviewFinanceModelRegionStep />
            </Suspense>
          </Step>
          <Step id="review" title="Review uploads" controls="manual">
            <ReviewFinanceModelStep {...props} />
          </Step>
        </Multistep>
      </CSVProvider>
    </Card>
  );

  return (
    <Modal className="md:max-w-4xl" {...props}>
      <Suspense fallback={<Loading />}>
        <BulkUploadFinanceModel />
      </Suspense>
    </Modal>
  );
};

export default BulkUploadFinanceModelModal;
